import { isFetchBaseQueryError } from '@afterpaytouch/portal-api'

export const extractApiError = (useRtkQuery: boolean, error: unknown): unknown =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useRtkQuery && isFetchBaseQueryError(error as any) ? (error as any).data : error
